import configService from './app-config.service';

const getAuthToken = async (instance, accounts) => {
    let tokenResponse;
    if (sessionStorage.getItem('isInternal') === 'true') {
        const accountScopes = configService.azureAdMsal.scope.scopes;
        tokenResponse = await instance.acquireTokenSilent({ scopes: accountScopes, account: accounts[0] });
    } else {
        const accountScopes = configService.azureB2CMsal.scope.scopes;
        tokenResponse = await instance.acquireTokenSilent({ scopes: accountScopes, account: accounts[0] });
    }

    return tokenResponse.idToken;
};

export { getAuthToken };
